export default __webpack_public_path__ + "static/media/icons-train-green-48-px.7a3c1a2a.svg";